// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"StepByStepCardModule_cardContainer__yxdbz","cardHeader":"StepByStepCardModule_cardHeader__-7sjv"};